export const MAPS_LIBRARIES = ['geometry']
export const MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
